import script from "./ControlRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlRenderer.vue?vue&type=script&setup=true&lang=js"

import "./ControlRenderer.vue?vue&type=style&index=0&id=254389b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254389b9"]])

export default __exports__